import React from "react";
import { Content } from "../../pages/Template";
import { Book, Results } from "../../components";
import { Books } from "../../models";
import { navigate } from "../../services";
import { docUrl, setWindowTitle } from "../../helpers";
import Tags from "../../components/Tags";
import Slider, { ItemProps } from "./Slider";
import { AxiosResponse } from "axios";

type Props = {};
type State = {
    list: ItemProps[];
    sliderIds: number[];
    stats: {
        offset: number;
        total: number;
    };
};

export class FeaturedPage extends React.Component<Props, State> {
    static paths = ["/app/"];

    constructor(props: Props) {
        super(props);
        this.state = {
            list: [],
            sliderIds: [],
            stats: {
                offset: 0,
                total: 0,
            },
        };
    }

    async componentDidMount() {
        setWindowTitle("اّردو کتب کا مرکز");
        await this.fetch();
    }

    loading = false;
    async fetch(concat = false) {
        if (this.loading) {
            return;
        }

        this.loading = true;

        try {
            const params = [
                "includeMeta=true",
                "includesPages=true",
                `offset=${concat ? this.state.stats.offset : 0}`,
            ];

            const {
                data: { list, stats },
            }: AxiosResponse<{
                list: ItemProps[];
                stats: {
                    offset: number;
                    total: number;
                };
            }> = await Books.list({
                url: params.join("&"),
            });
            this.setState({
                stats,
                list: concat ? this.state.list.concat(list) : list,
            });
            this.loading = false;
        } catch (e) {
            console.warn(e);
        }
    }

    onMore = async () => {
        await this.fetch(true);
    };

    onSliderFetch = (sliderIds: number[]) => this.setState({ sliderIds });

    render() {
        const { list, sliderIds, stats } = this.state;
        if (list.length === 0) {
            return null;
        }

        const showSlider = window.innerWidth > 600;
        // @ts-ignore
        const filtered = list.filter((i) => !sliderIds.includes(i.id));
        return (
            <Content>
                <Slider show={showSlider} onFetch={this.onSliderFetch} />

                <Tags />

                <Results stats={stats} onMore={this.onMore} enableMore={false}>
                    {filtered.map((item) => (
                        <Book
                            {...item}
                            width={220}
                            key={`book-${item.id}`}
                            onClick={() => navigate.to(docUrl(item))}
                        />
                    ))}
                </Results>
            </Content>
        );
    }
}
